<template>
  <v-layout justify-center>

    <loading :active.sync="busy"/>

    <v-dialog v-model="dialog_status" class="dialog-container"
      scrollable max-width="400px">
      <v-card>

        <v-card-title class="card-title">
          <span>{{ $t('update_project.update_project') }}</span>
          <v-btn icon @click="close()"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text>
          <v-flex xs12>
            <div class="card-text">{{ $t('update_project.title') }}</div>
            <v-text-field outlined dense
              :disabled="busy||is_inactive"
              v-model.trim.lazy="new_title"
              @input="is_duplicated=false"
              @blur="$v.new_title.$touch();checkTitle()"
              :error-messages="title_errors">
            </v-text-field>
          </v-flex>

          <v-flex xs12>
            <div class="card-text">{{ $t('update_project.description') }}</div>
            <v-textarea outlined
              :disabled="busy||is_inactive"
              v-model="new_description">
            </v-textarea>
          </v-flex>

          <v-flex xs12 class="input-row">
            <div class="row-title">{{ $t('update_project.status') }}</div>
            <v-radio-group class="small-radio"
              :disabled="busy||is_inactive"
              v-model="new_status" row>
              <v-radio v-for="(value, key) in project_status"
                :key="key"
                :value="parseInt(key)">
                <template v-slot:label>
                  {{ $t('update_project.'+value.name) }}
                </template>
              </v-radio>
            </v-radio-group>
          </v-flex>

          <!-- Date -->
          <!-- <v-flex xs12 v-if="new_status!=2" class="input-row">
            <div class="row-title">
              <span>Due date</span>
            </div>
            <v-menu
              ref="duedate"
              v-model="due_date_visible"
              :close-on-content-click="false"
              :return-value.sync="new_due_date"
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
              >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="new_due_date"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
                <v-date-picker
                  v-model="new_due_date"
                  type="date"
                  no-title>
                <v-spacer></v-spacer>
                <v-btn text @click="new_due_date=null;$refs.duedate.save(new_due_date)">Clear</v-btn>
                <v-btn text color="primary" @click="$refs.duedate.save(new_due_date)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex> -->

          <!-- Color -->
          <!-- <v-flex xs12 class="input-row">
            <div class="row-title">
              Color
            </div>
            <div>
              <span class="dot default-dot" @click="new_color=null"
                :class="{'selected-dot': !new_color}">
              </span>
              <span v-for="(c, i) in dot_colors" :key="i"
                class="dot" :style="setDotColor(i)" @click="new_color=c.color"
                :class="{'selected-dot':new_color==c.color}"></span>
            </div>
          </v-flex> -->

        </v-card-text>

        <v-card-actions>
          <v-btn small text color="red darken-1"
            :disabled="busy"
            @click="delete_dialog=true">
            {{ $t('update_project.delete_project') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small depressed color="primary"
            :disabled="is_duplicated||busy||is_inactive"
            @click="updateProject()">
            {{ $t('actions.save') }}
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <!-- Delete modal -->
    <template>
      <v-dialog v-model="delete_dialog" width="400px">
        <v-card>
          <v-card-title class="card-title-wrapper">
            <span>{{ $t('update_project.delete_project') }}</span>
            <v-btn icon @click="delete_dialog=false"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <div>
              {{ $t('update_project.delete_project_description',[ project_info.title ])}}
            </div>
          </v-card-text>
          <v-card-text v-if="!!project_info.num_docs">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-checkbox 
                    color="primary"
                    v-model="to_clip"
                    label="프로젝트 도큐먼트를 클립에 보관하기"
                    :disabled="user_type='basic'"
                  ></v-checkbox>
                </div>
              </template>
              <div>프리미엄 기능입니다</div>
            </v-tooltip>
          </v-card-text>
          <v-card-actions>
            <v-btn block depressed small color="primary"
              @click="deleteProject">
              {{ $t('actions.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

  </v-layout>
</template>

<script>
import { project_status } from '../../../custom/model'
import { toDatetime } from '../../../custom/function'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      busy: false,
      project_status: project_status,

      new_title: "",
      new_description: "",
      new_status: "",

      is_duplicated: false,

      to_clip: true,
      // new_color: null,

      // new_due_date: "",
      // due_date_visible: false,
      // due_date_selected: false,

      // dot_colors: [
      //   { color: '#D6CCD3' },
      //   { color: '#BED0BE' },
      //   { color: '#EEA2A9' },
      //   { color: '#D7E4E2' },
      //   { color: '#E3ECA6' },
      // ],

      delete_dialog: false,
    }
  },

  computed: {
    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },

    ...mapGetters({
      project_info: 'project/project_info',
      projects: 'project/projects',
      proj_docs: 'project/documents',
      user_type: 'user/user_type',
    }),

    proj_keys() {
      return this.proj_docs.map(v => v.key)
    },

    is_inactive() {
      return this.project_info.status >= 10
    },

    project_title_list() {
      return this.projects.map(proj => proj.title)
    },

    title_errors() {
      const errors = []
      if (!this.$v.new_title.$dirty) return errors
      !this.$v.new_title.required && errors.push(this.$t('update_project.required'))
      !this.$v.new_title.isUnique && errors.push(this.$t('update_project.available'))
      return errors
    },

  },

  watch: {
    project_info: {
      handler(val) {
        this.new_title = val.title
        this.new_description = val.description
        this.new_status = val.status
        this.new_mode = val.mode
        this.new_color = val.color
        this.new_due_date = !!val.due_date ? val.due_date.split(" ")[0] : null
      },
      immediate: true,
      deep: true,
    },
  },

  validations: {
    new_title: {
      required,
      isUnique() {
        return this.$v.new_title.$dirty &&
          this.$v.new_title.required &&
          !this.is_duplicated
      }
    },
  },

  methods: {
    toDatetime,

    checkTitle() {
      if(this.project_title_list.includes(this.new_title) &&
        this.new_title != this.project_info.title) {
          this.is_duplicated = true
        } else { this.is_duplicated = false }
    },

    async updateProject() {
      this.busy = true
      let error = false
      let completed_ts = this.new_status == 2 ?
        this.toDatetime(new Date()) : null
      try {
        await this.$store.dispatch('project/updateProject', {
          proj_id: this.project_info.proj_id,
          title: this.new_title,
          description: this.new_description,
          status: this.new_status,
          // color: this.new_color,
          // due_date: this.new_due_date,
          // due_date_null: this.new_status==2 || this.new_due_date==null,
          completed_ts,
        })
      } catch(e) {
        error = true
      } finally {
        if (!error) {
          this.$analytics.logEvent('click', { name: 'project_btn_update' })
        }
        this.busy = false
        this.initialize()
        this.close()
      }
    },

    async deleteProject() {
      let error = false
      try {
        this.close()
        if (this.to_clip&&this.user_type!='basic'&&!!this.project_info.num_docs) {
          let clip_id = this.projects.filter(v => v.mode == 9)[0].proj_id
          await this.$store.dispatch('project/addCopyDocumentsToProject', {
            proj_id: clip_id,
            documents: this.proj_keys,
          })
        }
        await this.$store.dispatch('project/deleteProject', {
          proj_id: this.project_info.proj_id
        })
      } catch(e) {
        error = true
      } finally {
        if (!error) {
          this.$analytics.logEvent('click', { name: 'project_btn_delete' })
        }
        await this.$router.replace({ name: 'lab' })
      }
    },

    initialize() {
      this.new_title = this.project_info.title
      this.new_description = this.project_info.description
      this.new_status = this.project_info.status
      this.is_duplicated = false
    },

    close() {
      this.initialize()
      this.$emit('update:dialog', false)
    },

    // setDotColor(index) {
    //   let color = this.dot_colors[index].color
    //   return 'background-color:'+ color
    // },
  },
}
</script>

<style scoped>
  .card-title {
    font-size: 1.25rem;
    letter-spacing: -.25px;
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .card-text {
    color: #485158;
  }

  .input-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 14px;
  }

  .row-title {
    padding-right: 16px;
    transform: translateY(-7px);
  }

  .input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center; 
    opacity: 0;
  }

  .input>div {
    width: 100%;
  }

  .input-row button {
    margin: 5px 0;
  }

  .card-title-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  /* .dot {
    height: 20px;
    width: 20px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    margin-right: 5px;
    transform: translateY(-5px);
    cursor: pointer;
  }

  .default-dot {
    background-color: rgba(237, 237, 237, 0.4);
  }

  .selected-dot {
    border: 1px #E0457A solid;
  } */
</style>



// WEBPACK FOOTER //
// src/components/modal/project/UpdateProject.vue